export default __webpack_public_path__ + "/public/icons/mtreat-transparentbg.png";